import { memo, PropsWithChildren } from 'react';

interface Props {
    className?: string;
    size?: 'md' | 'lg';
    title?: string;
    titleSize?: 'md' | 'lg';
    subTitle?: string;
    borderClass?: string;
    titleAlign?: 'left' | 'center' | 'right';
}

const Panel: React.FC<PropsWithChildren<Props>> = ({
    children,
    className,
    size = 'lg',
    title,
    titleSize = 'md',
    subTitle,
    borderClass = 'border border-gray-400',
    titleAlign = 'center'
}) => {

    let paddingClass = ''
    if ('md' === size) { paddingClass = 'px-4 pt-8  pb-8 md:px-8  md:pt-10 md:pb-10' }
    if ('lg' === size) { paddingClass = 'px-4 pt-10 pb-10 md:px-16 md:pt-14 md:pb-14' }

    let Title = null;
    if ('md' === titleSize) {
        Title = () => (<h2 className={`text-xl font-bold text-${titleAlign} `}>{title}</h2>)
    }
    if ('lg' === titleSize) {
        Title = () => (<h2 className={`text-2xl font-extrabold text-${titleAlign} `}>{title}</h2>)
    }

    const SubTitle = () => (<h3 className="w-full mx-auto mt-4 text-base text-center text-gray-600 md:w-2/3">{subTitle}</h3>)

    return (
        <div className={`w-full ${paddingClass} mb-8 bg-white ${borderClass} rounded-lg shadow-sm lg:shadow-lg ${className}`}>
            {title && (
                <div className="mb-8">
                    {title && <Title />}
                    {subTitle && <SubTitle />}
                </div>
            )}
            {children}
        </div>
    )
}

export default memo(Panel)